






























import Vue from 'vue'
import Component from 'vue-class-component'
import { IBarChartDataItem } from '@/interfaces'
import { IBarChartData } from '../../interfaces'

@Component({
  props: {
    type: {
      type: String,
      default: 'vertical'
    },
    config: {
      type: Object,
      default: {
        lineWidth: '42px'
      }
    },
    data: {
      type: Array,
      default: []
    }
  }
})
export default class BarChart extends Vue {
  getLineTitle (items: IBarChartDataItem[]) {
    const total = this.getLineNumber(items)
    return total  
  }
  getLineNumber (items: IBarChartDataItem[]) {
    const total = items.reduce((total: number, item: IBarChartDataItem) => total + item.value, 0)
    return total
  }
  isPick (item: IBarChartDataItem, items: IBarChartDataItem[]) {
    const pick = items.find((item) => {
      return item.value > 0
    })
    return pick === item
  }
  get maxLineNumber () {
    if (this.$props.config.total !== undefined) {
      return this.$props.config.total
    }
    const data = this.$props.data
    let max = 0
    for (let i = 0; i < data.length; i++) {
      const stepMax = this.getLineNumber(data[i].items)
      if (stepMax > max) {
        max = stepMax
      }
    }
    return max
  }
  getBoxStyles (item: IBarChartDataItem, data: IBarChartData) {
    const value = item.value
    if (this.$props.type === 'horizontal') {
      return {
        height: this.$props.config.lineWidth,
        backgroundColor: item.color,
        paddingRight: `${this.$props.config.boxSpace || 4}px`,
        width: `${value / this.getLineNumber(data.items) * 100}%`
      }
    }
    return {
      width: this.$props.config.lineWidth,
      backgroundColor: item.color,
      paddingTop: `${this.$props.config.boxSpace || 4}px`,
      height: `${value / this.getLineNumber(data.items) * 100}%`
    }
  }
  getLineStyles (items: IBarChartDataItem[], dataItem: IBarChartData) {
    const sum = this.getLineNumber(items)
    const max = this.maxLineNumber
    const space = this.$props.config.space || 25
    if (this.$props.type === 'horizontal') {
      return {
        height: '100%',
        width: !dataItem.title && sum === 0 ? 0 : `calc(${sum / max} * (100% - ${4 * space}px - ${space}px) + ${4 * space}px + ${space}px)`
      }
    }
    return {
      height: !dataItem.title && sum === 0 ? 0 : `calc(${sum / max} * (100% - ${space}px - ${space}px) + ${space}px + ${space}px)`
    }
  }
  getBoxTooltip (dataItem: IBarChartData) {
    let totalTitle = `<b>Total</b>: `
    if (this.$props.config.tooltipFormatter) {
      totalTitle += Vue.filter(this.$props.config.tooltipFormatter)(this.getLineNumber(dataItem.items))
    } else {
      totalTitle += this.getLineNumber(dataItem.items)
    }
    
    let title = [totalTitle]
      .concat(dataItem.items.map((item) => {
        if (item.label === undefined) {
          return ''
        }
        if (this.$props.config.tooltipFormatter) {
          return `${item.label} ${Vue.filter(this.$props.config.tooltipFormatter)(item.value)}`
        }
        return `${item.label} ${item.value.toString()}`
      }))
      .join('<br/>')
    return title
  }
}
